import angular from 'angular';
import ordersComponent from './orders.component';
import OrdersService from './orders.service';
import ordersConfig from './orders.config';
import SyncOrderModalController from './sync-order-modal/sync-order-modal.controller';
import orderDetailModule from './order-detail/order-detail';

import trackingModule from './tracking/tracking'

let ordersModule = angular.module('app.orders',[orderDetailModule.name,trackingModule.name])
  .component('orders', ordersComponent)
  .controller('SyncOrderModalController', SyncOrderModalController)
  .service('OrdersService', OrdersService)
  .config(ordersConfig);

export default ordersModule;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/orders/orders.js
 **/